import { IFCViewerV4ConfigOptions } from "./config"
import { usePubsub } from "../../../redux/pubsub"
import { useMemoizedFn } from "../../../hooks/use-memoized-fn"
import { StringListSerializer, useSyncPubSub } from "../../../hooks/use-sync-pub-sub"
import PublishUtils from "../../../helpers/PublishUtils"
import { useRef } from "react"

export function useSyncSelection(config: {
  widgetId: string
  selectionTopic: string | null | undefined,
  selectionSubscription: string | null | undefined,
  multipleselectparametertype: IFCViewerV4ConfigOptions["multipleselectparametertype"],
  namespace: string | null | undefined,
  zoomOnSelectionChange: boolean | null | undefined,
  setIfcSelection: (guids: string[], zoom: boolean) => void
}) {
  const [ , publish ] = usePubsub()
  const guidsPublishedByViewer = useRef<string[] | null>(null)

  const setAppvarSelection = useMemoizedFn((guids: string[]) => {
    if (!config.selectionTopic) return
    guidsPublishedByViewer.current = guids
    const multivalue = PublishUtils.getListAsSingleValue(config.multipleselectparametertype, guids)
    publish(config.selectionTopic, multivalue, "publish selection from 3D")
  })

  useSyncPubSub({
    enabled: Boolean(config.selectionSubscription),
    sourceId: config.widgetId,
    serializer: new StringListSerializer(config.multipleselectparametertype),
    subscribe: {
      topic: config.selectionSubscription,
      handleRepeatedValues: false,
      handleValue: (guids: string[]) => {
        const isRoundTrip = guidsPublishedByViewer.current != null && arraysEqual(guids, guidsPublishedByViewer.current)
        config.setIfcSelection(guids, !isRoundTrip && Boolean(config.zoomOnSelectionChange))
        guidsPublishedByViewer.current = null
      }
    }
  })

  return { setAppvarSelection } as const
}

function arraysEqual<T>(a: T[], b: T[]): boolean {
  if (a.length !== b.length) return false
  return a.every((val, i) => val === b[i])
}
